module.exports = __webpack_public_path__ + "static/media/long-page-checklist@2x.a87854b7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/long-page-checklist@2x.png
 ** module id = 2048
 ** module chunks = 44
 **/